import { useParams, Link } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MovieCard from '@/components/feature/MovieCard';
import { movies, categories } from '@/mocks/movies';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryName = currentCategory?.name || '全部';

  const filteredMovies = useMemo(() => {
    if (!slug) return movies;
    return movies.filter((m) => m.category === slug);
  }, [slug]);

  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: categoryName },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />

            <div className="mt-4">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-900">
                {categoryName}
              </h1>
              {currentCategory && (
                <p className="text-sm text-foreground-500 mt-1">
                  {currentCategory.description}
                </p>
              )}
            </div>

            <div className="mt-6 flex items-center gap-2 overflow-x-auto pb-2 flex-wrap">
              <Link
                to="/"
                className="px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer bg-background-100 text-foreground-600 hover:bg-background-200"
              >
                全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="mt-8">
              {filteredMovies.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                  {filteredMovies.map((movie) => (
                    <MovieCard key={movie.id} {...movie} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 text-foreground-300">
                    <i className="ri-movie-line text-4xl"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无内容，请查看其他分类</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}